import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Button } from '../button/button'
import { LinkButton } from '../button/link-button'
import { Icon } from '../icon/icon'
import Modal from '../modal/modal'
import Text from '~/components/text/text'

interface ShareEventModalProps {
	toggleModal: () => void
}

export default function ShareEventModal({ toggleModal }: ShareEventModalProps) {
	const [url, seturl] = useState('')
	const handleCopyLink = () => {
		navigator.clipboard.writeText(url)
		toggleModal()
	}
	const { t } = useTranslation()
	useEffect(() => {
		seturl(window.location.href)
	}, [])
	return (
		<Modal onClose={toggleModal} title={t('share_event_title')}>
			<div className="flex flex-col">
				<div className="py-4">
					<Text>
						{t('share_event_description', { iconOne: '🎉', iconTwo: '😍' })}
					</Text>
				</div>
				<div className="grid grid-cols-2 gap-2">
					<Button
						className="col-span-2 md:col-span-1"
						variant="outline-light"
						onClick={handleCopyLink}
					>
						<Icon name="copy">{t('action_copy')}</Icon>
					</Button>
					<LinkButton
						className="col-span-2 md:col-span-1"
						variant="outline-light"
						external
						to={`mailto:?Subject=Upplev detta med mig!&body=Hej, spana in det här evenemanget, det måste vi uppleva tillsammans!! ${url}`}
					>
						<Icon name="envelope">{t('misc_email')}</Icon>
					</LinkButton>
					<LinkButton
						external
						className="col-span-2 md:col-span-1 md:hidden"
						variant="outline-light"
						to={`sms:?&body=Hej, spana in det här evenemanget, det måste vi uppleva tillsammans!! ${url}`}
					>
						<Icon name="chat-bubble">{t('misc_messages')}</Icon>
					</LinkButton>
				</div>
			</div>
		</Modal>
	)
}
